import axios from "./axios";
import { handleApiError } from './apiErrorHandler';

export default {
  login: async (credentials) => {
    try {
      const response = await axios.post("/auth/login", credentials);
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error);
    }
  },

   signup: async (userData) => {
    try {
      const response = await axios.post("/auth/signup", userData);
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error);
    }
  },
};
